import { useLocalStore } from "mobx-react";

/**
 * Manages the state of selected items in groups of checkboxes or similar
 * @param items
 */
export function useSelection() {
  const selectState = useLocalStore(() => ({
    selected: [] as string[],
    items: [] as string[],

    get allSelected() {
      return this.selected.length > 0 && this.selected.length === this.items.length;
    },

    get empty() {
      return this.selected.length === 0;
    },

    reset(items: string[]) {
      this.items = items;
      this.selected = [];
    },

    toggle(item: string) {
      this.isSelected(item) ? this.deselect(item) : this.select(item);
    },

    select(item: string) {
      if (!this.items.includes(item)) {
        return;
      }

      this.selected = [...this.selected, item].unique();
    },

    deselect(item: string) {
      this.selected = this.selected.removeElementPure((x) => item === x);
    },

    toggleAll() {
      if (this.items.length === 0 || this.selected.length === this.items.length) {
        this.selected = [];
        return;
      }

      this.selected = [...this.items];
    },

    isSelected(item: string) {
      return this.selected.includes(item);
    }
  }));

  return selectState;
}
